import React from 'react';
import { useHistory } from 'react-router-dom';

import { FaCity, FaClipboardCheck, FaRegMap } from 'react-icons/fa';
import { RiDatabaseFill } from 'react-icons/ri';
import { BsFillPeopleFill } from 'react-icons/bs';
import Card from '~/Components/Card';
import { COLORS } from '~/styles/colors';

const ServicosPrefeitura = () => {
	const history = useHistory();

	return (
		<div
			style={{
				backgroundColor: '#fff',
				width: '100%',
				padding: '30px',
			}}
		>
			<h1 style={{ fontSize: '17pt', marginBottom: '7px' }}>
				SERVIÇOS PREFEITURA
			</h1>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					flexWrap: 'wrap',
				}}
			>
				{/* <Card
					backgroundColor={COLORS.bgCard2}
					textColor={COLORS.fgCard2}
					href="https://cidadao.divinopolis.mg.gov.br/portalcidadao/"
					icon={<BsFillPeopleFill size={48} color={COLORS.fgCard2} />}
					text={
						<span
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<span>PORTAL </span>
							<span>CIDADÃO</span>
						</span>
					}
				/> */}
				<Card
					backgroundColor={COLORS.bgCard2}
					textColor={COLORS.fgCard2}
					onClick={() =>
						history.push('/media/legislacao-urbanistica')
					}
					icon={<FaCity size={48} color={COLORS.fgCard2} />}
					text={
						<span
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<span>LEGISLAÇÃO</span>
							<span>URBANISTICA</span>
						</span>
					}
				/>
				<Card
					backgroundColor={COLORS.bgCard2}
					textColor={COLORS.fgCard2}
					onClick={() => history.push('/media/aprovacao-de-projetos')}
					icon={<FaClipboardCheck size={48} color={COLORS.fgCard2} />}
					text={
						<span
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<span>APROVAÇÃO DE</span>
							<span>PROJETOS</span>
						</span>
					}
				/>
				<Card
					backgroundColor={COLORS.bgCard2}
					textColor={COLORS.fgCard2}
					onClick={() =>
						history.push('/media/acervo-cartografico-municipal')
					}
					icon={<FaRegMap size={48} color={COLORS.fgCard2} />}
					text={
						<span
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<span>ACERVO</span>
							<span>CARTOGRÁFICO</span>
							<span>CADASTRAL</span>
						</span>
					}
				/>
				<Card
					backgroundColor={COLORS.bgCard2}
					textColor={COLORS.fgCard2}
					onClick={() => history.push('/media/divinopolis-em-dados')}
					icon={<RiDatabaseFill size={48} color={COLORS.fgCard2} />}
					text={
						<span
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<span>DIVINÓPOLIS</span>
							<span>EM DADOS</span>
						</span>
					}
				/>
			</div>
		</div>
	);
};

export default ServicosPrefeitura;
